import React, { useState } from 'react';

function StepFour({ formData, onNext }) {
    const [takesMedication, setTakesMedication] = useState(formData.takesMedication || '');
    const [medicationDetails, setMedicationDetails] = useState(formData.medicationDetails || '');
    const [error, setError] = useState('');

    const handleContinue = () => {
        if (!takesMedication) {
            setError('Please select Yes or No.');
            return;
        }

        if (takesMedication === 'yes' && !medicationDetails.trim()) {
            setError('Please list your prescribed medication.');
            return;
        }

        setError('');
        onNext({ takesMedication, medicationDetails });
    };

    const isFormValid =
        takesMedication === 'no' ||
        (takesMedication === 'yes' && medicationDetails.trim());

    return (
        <div className="step-form">
            <h6 className="mb-4">General Health</h6>

            {error && <div className="alert alert-danger">{error}</div>}

            <p>Are you currently taking any prescribed medication? <span className="text-danger">*</span></p>
            <div className="row">
                <div className="col-lg-6">
                    <div className="form-check mb-2">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="prescribedMedication"
                            id="medicationYes"
                            value="yes"
                            checked={takesMedication === 'yes'}
                            onChange={() => setTakesMedication('yes')}
                        />
                        <label className="form-check-label" htmlFor="medicationYes">
                            Yes
                        </label>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="form-check mb-3">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="prescribedMedication"
                            id="medicationNo"
                            value="no"
                            checked={takesMedication === 'no'}
                            onChange={() => setTakesMedication('no')}
                        />
                        <label className="form-check-label" htmlFor="medicationNo">
                            No
                        </label>
                    </div>
                </div>
            </div>

            {takesMedication === 'yes' && (
                <div className="mb-3">
                    <label className="form-label">Please list:</label>
                    <textarea
                        className="form-control"
                        placeholder="Please list your prescribed medication"
                        rows="4"
                        value={medicationDetails}
                        onChange={e => setMedicationDetails(e.target.value)}
                    />
                </div>
            )}

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!isFormValid}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default StepFour;
